@if (data) {
  <div class="main-withdraw-container">
    @for (element of data; track element) {
      <div class="image-content">
        <img
          class="image-cohort"
          src="{{ element.cohortIcon }}"
          matTooltip="{{ element.cohortCode }}"
          alt="{{ element.cohortCode }}" />
        @if (element.requestToPendingEnabled) {
          <div class="display-inline">
            Automatically moving to PENDING after {{ element.requestedToPendingInMinutes }} minutes and
          </div>
        }
        @if (!element.requestToPendingEnabled) {
          <div class="display-inline">Automatically moving to PENDING is <b>DISABLED</b> and</div>
        }
        @if (element.pendingToAcceptedEnabled) {
          <div class="display-inline">
            &nbsp;Automatic ACCEPTING after {{ element.pendingToAcceptedInMinutes }} minutes.
          </div>
        }
        @if (!element.pendingToAcceptedEnabled) {
          <div class="display-inline">&nbsp;Automatic ACCEPTING is <b>DISABLED</b>.</div>
        }
      </div>
    }
  </div>
}
